import { MainService, IHBSUSER } from './../_services/main.service';
import { ApiService } from './../_services/api.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsPaidGuard implements CanActivate {
  constructor(private api: ApiService, private main: MainService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // console.log("IsPaidGuard");
    let status: boolean = true;
    if (Object.keys(this.main.me?.profile || {}).length) {
      // console.log("1")
      status = this.checkPaidStatus();
      // console.log("status1", status);
    }
    else {
      // console.log("2");
      this.api.get('me/info', {}).subscribe((v: any) => {
        if (!this.main.me) {
          this.main.me = { profile: v.data.user_data } as IHBSUSER;
          // console.log("Condition True", this.main.me);
          status = this.checkPaidStatus();
        }
        else {
          this.main.me.profile = v.data.user_data;
          // console.log("Condition False", this.main.me.profile);
          status = this.checkPaidStatus();
        }
      });
    }
    // console.log("status", status);
    return status;
  }

  checkPaidStatus(): boolean {
    if (this.main.me.profile.paid != undefined && this.main.me.profile.paid == false) {
      // console.log("checkPaidStatus-1");
      this.router.navigate(['payments']);
      return false;
    }
    else {
      // console.log("checkPaidStatus-2");
      return true;
    }
  }
}
